import React from 'react'
import { faUserGear } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Dialog } from 'primereact/dialog'
import { Password } from 'primereact/password'
import { Button } from 'primereact/button'


const DialogPassword = ({display, selected, loading, authByUserOrRol, authPermiso, onHide, password, setPassword, showInput= true}) => {

    
    const renderFooter = () => {
        return (
          <div>
            <Button label="Cancelar" className='p-button-outlined' icon="pi pi-times" onClick={() => onHideT()} />
            <Button label="Aceptar" disabled={loading} loading={loading} icon="pi pi-check" onClick={() => authPermiso(password)} />
          </div>
        );
      }

      const onHideT = () => {
         onHide();
         setPassword('');
      }


    return (
        <div>
            <Dialog className={'modal__contenedor '} closable={false} header="Acceso" visible={display} breakpoints={{ '960px': '75vw' }} style={{ width: '400px' }} footer={renderFooter('displayResponsive')}>

                <div className='d-flex flex-column  justify-content-center'>
                    <strong>{selected.length === 0 ? 1 + ' Item a aprobar' : selected.length + ' Items a aprobar'}.</strong>
                    {showInput && <strong>Ingrese la contraseña.</strong>}
                    <div style={{ height: 0, overflow: 'hidden' }}>
                        <input style={{ height: 0 }} />
                        <input name='user'></input>
                        <Password />
                    </div>
                    {showInput &&<div className='p-inputgroup'>
                         <Password autoComplete="new-password" type='text' value={password} onChange={(e) => setPassword(e.target.value)} feedback={false} />
                        <Button disabled={loading} loading={loading} onClick={authByUserOrRol}><FontAwesomeIcon icon={faUserGear} /></Button>
                    </div>}

                </div>
            </Dialog>
        </div>
    )
}

export default DialogPassword